import { Icon } from 'antd';
import * as React from 'react';
import HelpModal from './HelpModal';

export default class Help extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      helpDisplay: false
    }
  }

  onShowHelp = () => {
    this.setState({helpDisplay: true})
  };

  onHideHelp = () => {
    this.setState({helpDisplay: false})
  };

  render() {
    return (
      <div style={{display: "inline", float: "right"}}>
        <Icon type="question-circle" theme='twoTone' style={{ cursor: "pointer", fontSize: '1.4em' }} onClick={this.onShowHelp}/>
        <HelpModal visibility={this.state.helpDisplay} onHideHelp={this.onHideHelp} selectedMenu="1"/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Help.tsx